/*
 * Copyright © 2025 AionTrack. All rights reserved.
 */

import { z } from 'zod'

export const tagSchema = z.object({
  name: z.string()
    .min(1, 'Tag name is required')
    .max(100, 'Tag name is too long')
    .regex(/^[A-Za-z0-9_]+$/, 'Tag name must contain only letters, numbers, and underscores'),
  display_name: z.string()
    .min(1, 'Display name is required')
    .max(100, 'Display name is too long')
    .regex(/^#/, 'Display name must start with #'),
  color: z.string()
    .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid color format (must be hex like #8b5cf6)'),
  description: z.string().max(500, 'Description is too long').optional(),
})

export const tagUpdateSchema = z.object({
  display_name: z.string()
    .min(1, 'Display name is required')
    .max(100, 'Display name is too long')
    .regex(/^#/, 'Display name must start with #')
    .optional(),
  color: z.string()
    .regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid color format (must be hex like #8b5cf6)')
    .optional(),
  description: z.string().max(500, 'Description is too long').optional(),
})

export type TagFormData = z.infer<typeof tagSchema>
export type TagUpdateFormData = z.infer<typeof tagUpdateSchema>

// Predefined color palette for tags
export const TAG_COLORS = [
  { name: 'Purple', value: '#8b5cf6' },  // VFX
  { name: 'Blue', value: '#3b82f6' },    // Dailies
  { name: 'Green', value: '#10b981' },   // Stock
  { name: 'Yellow', value: '#f59e0b' },  // Graphics
  { name: 'Red', value: '#ef4444' },     // Audio
  { name: 'Pink', value: '#ec4899' },
  { name: 'Indigo', value: '#6366f1' },
  { name: 'Cyan', value: '#06b6d4' },
  { name: 'Orange', value: '#f97316' },
  { name: 'Teal', value: '#14b8a6' },
  { name: 'Lime', value: '#84cc16' },
  { name: 'Gray', value: '#6b7280' },
] as const
